import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getAgentsUserById, defaultAgentsUserData, updateAgentsUser, createAgentsUser, getRoles, getAgentWiseDealers } from '@/api/agents-users';
import { getBranches } from '@/api/locations/branches';
import { AppModule } from '@/store/modules/app';
import { TagsViewModule } from '@/store/modules/tags-view';
import router from '@/router';
import { Action } from 'vuex-module-decorators';
import { AdminModule } from '@/store/modules/admin';
import { getQuery } from '@/utils';
import { isSuperAdmin } from '@/common';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.formData = Object.assign({}, defaultAgentsUserData);
    this.loading = false;
    this.adminToken = AdminModule;
    this.isOwner = false;
    this.roleList = [];
    this.dealerList = [];
    // protected selectedRoles: any = [];
    this.selectedRoles = null;
    this.selectedDealerIds = [];
    this.changePassword = false;
    this.branches = [];
    this.branchesLoading = false;
    this.assignedBranches = [];
    this.rules = {
      fullName: [{
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }, {
        min: 3,
        max: 150,
        message: 'Length should be 3 to 150',
        trigger: 'blur'
      }],
      emailAddress: [{
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }, {
        type: 'email',
        required: true,
        message: 'Please enter valid email',
        trigger: 'change'
      }],
      mobileNumber: [{
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }, {
        pattern: /^\d+$/,
        message: 'Please enter numbers only',
        trigger: 'blur'
      }, {
        min: 10,
        max: 10,
        message: 'Length should be 10 only',
        trigger: ['blur']
      }],
      agentId: [{
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }]
    };
  }
  get lang() {
    return AppModule.language;
  }
  checkOwnerRole() {
    // Check if the selected roles include the "Owner" role
    const ownerRole = this.roleList.find(role => role.name === 'Owner');
    this.isOwner = this.selectedRoles === (ownerRole === null || ownerRole === void 0 ? void 0 : ownerRole.id);
  }
  activated() {
    this.fetchRoles();
    if (this.isEdit) {
      const id = parseInt(this.$route.params && this.$route.params.id);
      this.fetchData(id);
    } else {
      this.formData = Object.assign({}, defaultAgentsUserData);
      const agentId = parseInt(this.$route.params && this.$route.params.agentId);
      this.formData.agentId = agentId;
      this.getAgentDealersList({
        agentId,
        isNew: true
      });
      this.assignedBranches = [];
    }
    if (this.isSuperAdminUser()) {
      this.fetchBranches();
    }
    this.tempTagView = Object.assign({}, this.$route);
  }
  isSuperAdminUser() {
    return isSuperAdmin();
  }
  async fetchBranches() {
    this.branchesLoading = true;
    try {
      this.branches = await getBranches(getQuery({
        enabled: true,
        sort: 'code,ASC',
        filter: {
          enabled: 'eq'
        }
      }));
    } catch (error) {
      console.error('Error fetching branches:', error);
      this.$notify({
        title: 'Error',
        message: 'Failed to load branches',
        type: 'error',
        duration: 2000
      });
    } finally {
      this.branchesLoading = false;
    }
  }
  async getAgentDealersList(params) {
    const data = await getAgentWiseDealers(params);
    this.dealerList = data;
  }
  async fetchData(id) {
    try {
      const data = await getAgentsUserById(id);
      this.formData = data;
      await this.getAgentDealersList({
        agentId: data.agentId,
        mappedAgentId: data.id
      });
      // populate selected role
      if (data.roles && data.roles.length) {
        var _data$roles$;
        // this.selectedRoles = data.roles.map((role: any) => role.id);
        this.selectedRoles = (_data$roles$ = data.roles[0]) === null || _data$roles$ === void 0 ? void 0 : _data$roles$.id;
        this.checkOwnerRole();
      }
      // populate selected dealers
      if (data.assignedDealers && data.assignedDealers.length) {
        this.selectedDealerIds = data.assignedDealers.map(dealer => dealer.id);
      }
      if (data.branches && data.branches.length) {
        this.assignedBranches = data.branches.map(branch => branch.id);
      }
      const title = this.formData.fullName;
      // Set tagsview title
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
    } catch (err) {} // eslint-disable-line  no-empty
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  async fetchRoles() {
    try {
      this.roleList = await getRoles(getQuery({
        enabled: true,
        sort: 'name,ASC',
        filter: {
          enabled: 'eq'
        }
      }));
    } catch (err) {} // eslint-disable-line  no-empty
  }
  canChangePassword() {
    // check if super admin
    // if (this.adminToken.adminsRoleId === 1) {
    //   return true
    // }
    // multi user condition change
    if (this.adminToken.adminsRoleIds.includes(1)) {
      return true;
    }
    // don't allow to change password otherwise
    return false;
  }
  resetPassword() {
    if (!this.changePassword) {
      this.formData.password = '';
    }
  }
  resetForm() {
    this.$refs.formData.resetFields();
  }
  async saveForm() {
    try {
      this.loading = true;
      this.formData.agent = {
        id: this.formData.agentId
      };
      // if (this.selectedRoles.length > 0) {
      //   this.formData.roles = this.selectedRoles.map((id: number) => ({
      //     id,
      //   }));
      // }
      if (this.selectedRoles) {
        this.formData.roles = [{
          id: this.selectedRoles
        }];
      }
      if (this.selectedDealerIds.length > 0) {
        this.formData.assignedDealers = this.selectedDealerIds.map(id => ({
          id
        }));
      } else {
        this.formData.assignedDealers = [];
      }
      if (this.isSuperAdminUser() && this.assignedBranches.length) {
        this.formData.branches = this.assignedBranches.map(id => ({
          id
        }));
      } else {
        this.formData.branches = [];
      }
      if (this.isEdit) {
        // update user
        await updateAgentsUser(this.formData.id, this.formData);
      } else {
        // this.formData.roles = this.selectedRoles.map((id: number) => ({
        //   id,
        // }));
        if (this.selectedRoles) {
          this.formData.roles = [{
            id: this.selectedRoles
          }];
        }
        if (this.selectedDealerIds.length) {
          this.formData.assignedDealers = this.selectedDealerIds.map(id => ({
            id
          }));
        } else {
          this.formData.assignedDealers = [];
        }
        await createAgentsUser(this.formData);
      }
      this.loading = false;
      this.$notify({
        title: 'Success',
        message: 'Agents User saved',
        type: 'success',
        duration: 2000
      });
      router.push({
        path: '/agents-users/list/' + this.formData.agentId
      });
    } catch (err) {
      if (err instanceof Error) {
        this.$notify.error({
          title: 'Error',
          message: err.message
        });
      }
      this.loading = false;
    }
  }
};
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'AgentsUserDetail',
  components: {}
})], default_1);
export default default_1;